import { Action } from '@ngrx/store';

import { ErrorResponse } from '~shared/models';
import { Category } from '~app/modules/generic/models';

export enum CategoriesActionTypes {
  LOAD_CATEGORIES = '[New Category] New Categories Load',
  LOAD_CATEGORIES_SUCCESS = '[New Category] New Categories Load Success',
  LOAD_CATEGORIES_FAILURE = '[New Category] New Categories Load Failed',
}

export class LoadCategories implements Action {
  type = CategoriesActionTypes.LOAD_CATEGORIES;
}

export class LoadCategoriesSuccess implements Action {
  type = CategoriesActionTypes.LOAD_CATEGORIES_SUCCESS;

  constructor(public payload: Category[]) {

  }
}

export class LoadCategoriesFailure implements Action {
  type = CategoriesActionTypes.LOAD_CATEGORIES_FAILURE;

  constructor(public payload: { error: ErrorResponse }) {

  }
}

export type CategoriesActionsUnion = LoadCategories | LoadCategoriesSuccess | LoadCategoriesFailure;


